import { useEffect } from "react";
import { SITE_URL } from "../data/site";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const useSeo = (title, description) => {
  useEffect(() => {
    const full = title.includes("B Digital Studio") ? title : `${title} | B Digital Studio`;
    const url = SITE_URL + window.location.pathname.replace(/\/+$/, "");
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url || SITE_URL);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url || SITE_URL);
  }, [title, description]);
};
